export const linkToRoles = () =>
  "/app/settings/roles-and-permissions?tab=roles";

export const ROLES_BREADCRUMB = {
  title: "Roles",
  path: linkToRoles,
};
